module.exports = __webpack_public_path__ + "static/media/icon-csn-net.1715eecf.png";